module.exports = __webpack_public_path__ + "static/media/confetti.389a8a85.gif";